import { jsx as I } from "react/jsx-runtime";
import { Root as v } from "@radix-ui/react-toast";
import P from "classnames";
import { useRef as E, useEffect as S } from "react";
import { noop as b } from "lodash/fp";
import { usePrimitiveToastPosition as x } from "./index.es5485.js";
import t from "./index.es760.js";
const F = "primitive-toast-component", C = ({
  open: i,
  testId: m = F,
  children: n,
  duration: a = 3e3,
  variant: c = "default",
  position: o = "bottom-right",
  isInStack: e,
  isFlashMessage: f,
  customPositioning: p,
  onOpenChange: l = b
}) => {
  const r = E(null), u = c === "inverted", d = o.split("-"), T = P(t.notificationContainer, {
    [t.inverted]: u,
    [t.isInStackFromTop]: e && o.includes("top"),
    [t.isInStackFromBottom]: e && o.includes("bottom")
  });
  return x(d, p, f), S(() => {
    setTimeout(() => {
      var s;
      (s = r.current) == null || s.focus();
    }, 20);
  }, []), /* @__PURE__ */ I(
    v,
    {
      className: T,
      open: i,
      onOpenChange: l,
      "data-testid": m,
      duration: a,
      type: "foreground",
      role: "alert",
      ref: r,
      tabIndex: 0,
      children: n
    }
  );
};
export {
  F as PRIMITIVE_TOAST_DEFAULT_TESTID,
  C as PrimitiveToast
};
//# sourceMappingURL=index.es752.js.map
